/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import './DisclaimerRendererStyles.scss';
const baseClass = 'qmb-ui-DisclaimerRenderer';
export function DisclaimerRenderer({ block }) {
    const disclaimer = block;
    const className = `${baseClass} ${baseClass}--${disclaimer.severity}`;
    return (React.createElement("div", { className: className },
        React.createElement("i", { className: "fa-light fa-shield-check" }),
        React.createElement(Text, { variant: "body", className: `${baseClass}__text` }, disclaimer.text)));
}
